var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTensionArterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.889,
    height: 12.388,
    viewBox: "0 0 36.889 12.388",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13033",
    "data-name": "Group 13033",
    transform: "translate(-523.479 -268.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6194",
    "data-name": "Path 6194",
    d: "M6.194,0A6.194,6.194,0,1,1,0,6.194,6.194,6.194,0,0,1,6.194,0Z",
    transform: "translate(523.479 268.306)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13032",
    "data-name": "Group 13032"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_285",
    "data-name": "Ellipse 285",
    cx: 3.709,
    cy: 3.709,
    rx: 3.709,
    ry: 3.709,
    transform: "translate(525.963 270.791)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7268",
    "data-name": "Path 7268",
    d: "M-17531.5-5776.2h23.5",
    transform: "translate(18067.367 6050.701)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTensionArterial);
export default __webpack_public_path__ + "static/media/icon-tension_arterial.f52ed2c5830d811f676b55d7946be44c.svg";
export { ForwardRef as ReactComponent };